import React, { FC, memo } from 'react'
import * as S from './styles'
import { PlaceholderProps } from './types'

export const Placeholder: FC<PlaceholderProps> = memo(({ kind = 'product', height }) => {
  if (kind === 'banner') {
    return <S.Banner />
  }

  if (kind === 'product') {
    return (
      <S.Product>
        <S.Image />
        <S.Texts />
      </S.Product>
    )
  }

  if (kind === 'texts') {
    return <S.Texts />
  }

  if (kind === 'title') {
    return <S.Title />
  }

  if (kind === 'card') {
    return <S.Card height={height} />
  }

  return <S.Image />
})

Placeholder.displayName = 'Placeholder'
